import { useContext } from "react";
import { useFormState } from "react-final-form";

import { FontIcon, Stack, useTheme } from "@bps/fluent-ui";
import { ClaimStatuses } from "@libs/gateways/acc/AccGateway.dtos.ts";
import { isDeepEmptyUtils } from "@libs/utils/isDeepEmpty.utils.ts";
import { Validator } from "@libs/validation/Validator.ts";
import { ClaimFormValues } from "@shared-types/acc/claim-form-values.type.ts";

import { ClaimContext } from "../context/ClaimContext.ts";

interface ClaimFormSideMenuTextProps {
  text: string;
  validator: Validator<object>;
}

export const ClaimFormSideMenuText = (props: ClaimFormSideMenuTextProps) => {
  const theme = useTheme();
  const { values } = useFormState<ClaimFormValues>();
  const { claim } = useContext(ClaimContext);

  const isViewMode =
    claim.isViewMode || claim.claimStatus === ClaimStatuses.Accredited;

  const isComplete = isDeepEmptyUtils(props.validator.validate(values));

  return (
    <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="center">
      <span>{props.text}</span>
      {!isViewMode && isComplete && (
        <FontIcon
          iconName="Completed"
          styles={{ root: { color: theme.palette.greenDark } }}
        />
      )}
    </Stack>
  );
};
